module.exports = __webpack_public_path__ + "assets/65f887dd54bea7fb7eadbc116618a0b9.png";